import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Text, Button } from 'mintel-react-ui';

import PageWrapper from '../../PageWrapper';
import useTranslation from '../../translations';
import { changeLanguage } from '../../shared/utils';
import { HELPDESK_EMAIL } from '../../shared/constants';
import { StringSelectField } from '../../fields';
import { SelectWrapper, HiddenFields } from '../../InputWrapper';
import styles from './RegisterUserGroup.scss';
import ThankYouMessage from '../SharedComponents';

export type RegisterUserGroupProps = {
  fields: { usergroup: StringSelectField };
  language?: string;
};

const RegisterUserGroup = ({
  fields,
  language = 'en',
}: RegisterUserGroupProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  const [usergroups, setUsergroups] = useState(
    fields.usergroup?.value ? [fields.usergroup.value] : [],
  );

  return (
    <PageWrapper>
      <form method="POST">
        <div className={styles.root}>
          <Text.Heading2>{t('Registration')}</Text.Heading2>
          <ThankYouMessage />
          <Text.Body2>
            <Trans>
              Based on the details you have supplied, you have a choice of which
              user group to join. Please click the one that appears closest to
              your role. If you make a mistake, please contact{' '}
              <a href={`mailto:${HELPDESK_EMAIL}`}>Helpdesk</a> or your Account
              Manager.
            </Trans>
          </Text.Body2>
          <SelectWrapper
            {...fields.usergroup}
            selected={usergroups}
            onSelect={setUsergroups}
            label={t('User Group')}
            searchable
            required
          />
          <div className={styles.button}>
            <Button.ActionButton
              type="submit"
              fullWidth
              handleClick={() => {}}
              disabled={!usergroups.length}
            >
              {t('Submit')}
            </Button.ActionButton>
          </div>
        </div>
        <HiddenFields fields={fields} />
      </form>
    </PageWrapper>
  );
};

export default RegisterUserGroup;
